import { render, staticRenderFns } from "./footBottom.vue?vue&type=template&id=bd447950&scoped=true"
import script from "./footBottom.vue?vue&type=script&lang=js"
export * from "./footBottom.vue?vue&type=script&lang=js"
import style0 from "./footBottom.vue?vue&type=style&index=0&id=bd447950&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd447950",
  null
  
)

export default component.exports